import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '@nanostores/react';
import { $auth } from '../store/auth';
import { useAuthContext } from '../AuthProvider';

type ProtectedRouteProps = {
  subscriptionRequired?: boolean;
  proRequired?: boolean;
  redirectIfSubscribed?: boolean;
  feature?: string;
};
export const ProtectedRoute: FC<PropsWithChildren<ProtectedRouteProps>> = ({
  children,
  subscriptionRequired,
  proRequired,
  redirectIfSubscribed,
  feature,
}) => {
  const authStore = useStore($auth);
  const authContext = useAuthContext();

  if (authContext.loading) {
    return null;
  }

  let forceRejected = false;
  if (feature !== undefined) {
    if (
      authStore?.user?.userAttributes?.[`custom:feature_${feature}`] !==
      'enabled'
    ) {
      forceRejected = true;
    }
  }

  if (!authStore.isLoggedIn || forceRejected) {
    return <Navigate to="/auth" replace />;
  }

  if (
    redirectIfSubscribed &&
    (authStore?.user?.isPro ||
      authStore?.user?.isBasic ||
      authStore?.user?.isAdmin)
  ) {
    return <Navigate to="/" replace />;
  }

  // Pro-only routes: a Basic subscription is not enough, only Pro (and admins).
  if (proRequired && !authStore?.user?.isPro && !authStore?.user?.isAdmin) {
    return <Navigate to={'/subscribe'} replace />;
  }

  if (
    !subscriptionRequired ||
    authStore?.user?.isPro ||
    authStore?.user?.isBasic ||
    authStore?.user?.isAdmin
  ) {
    return <>{children}</>;
  }
  if (
    subscriptionRequired &&
    !authStore?.user?.isPro &&
    !authStore?.user?.isBasic &&
    !authStore?.user?.isAdmin
  ) {
    return <Navigate to={'/subscribe'} replace />;
  }

  return null;
};
